<section class="page-section about-section" id="about">
  <div class="container">

    <div class="text-center mb-2">
      <h2 class="section-heading">{{'ABOUT' | translate}}</h2>
      <div class="section-heading-line mx-auto"></div>
    </div>

    <app-icone-divider></app-icone-divider>

    <div class="row about-cards justify-content-center">
      <div class="col-lg-5 col-md-10 mb-4 mb-lg-0">
        <div class="about-card">
          <div class="about-icon-wrap">
            <i class="fas fa-tshirt"></i>
          </div>
          <p class="pre-wrap about-text">{{'ABOUT_MY_APPLICATION' | translate}}</p>
        </div>
      </div>
      <div class="col-lg-5 col-md-10">
        <div class="about-card">
          <div class="about-icon-wrap">
            <i class="fas fa-user-circle"></i>
          </div>
          <p class="pre-wrap about-text">{{'ABOUT_WEBDESIGNER' | translate}}</p>
        </div>
      </div>
    </div>

  </div>
</section>
